'use client';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';

import StandardLayout from 'components/layout/StandardLayout';

// TODO: Hardik - check do we need DynamicComponentWithNoSSR
const UserLogin = dynamic(
  () => import('components/atomic/molecules/login/UserLogin'),
  {
    ssr: false
  }
);

export default function LoginClient() {
  return (
    <StandardLayout
      {...{
        showHeader: false,
        showLoader: false
      }}
    >
      <Suspense fallback={<div>Loading...</div>}>
        <UserLogin />
      </Suspense>
    </StandardLayout>
  );
}
